import styled from "styled-components";

export const ErrorDiv = styled.section`
  width: 100%;
`;

export const ErrorWrapper = styled.div`
  align-items: center;
  background-color: #fff;
  border: 1px solid #ff5200;
  border-radius: 4px;
  color: #ff5200;
  display: flex;
  grid-template-columns: 1fr 1fr;
  font-family: Lato;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  padding: 0.625rem;
  position: relative;
  -webkit-box-pack: justify;
`;
export const ErrorText = styled.p`
  float: left;
  margin: 0 0.625rem 0 0;
  display: flex;
`;

export const ErrorPara = styled.div`
  display: flex;
  flex-direction: column;
`;
